__turbopack_context__.v({
  "choice": "BlockTypePicker-module__v6m-7a__choice",
  "copy": "BlockTypePicker-module__v6m-7a__copy",
  "desc": "BlockTypePicker-module__v6m-7a__desc",
  "example": "BlockTypePicker-module__v6m-7a__example",
  "grid": "BlockTypePicker-module__v6m-7a__grid",
  "group": "BlockTypePicker-module__v6m-7a__group",
  "groupTitle": "BlockTypePicker-module__v6m-7a__groupTitle",
  "icon": "BlockTypePicker-module__v6m-7a__icon",
  "label": "BlockTypePicker-module__v6m-7a__label",
  "root": "BlockTypePicker-module__v6m-7a__root",
});
